export default "__VITE_ASSET__DXq7wehs__"